var $ = require('jquery');
    module.exports = {
       // props: ['items'],
        data:function(){
            return {
              param:this.$route.params.id
            }
        },
        ready:function(){
                // === Sidebar navigation === //
               
                $('.submenu > a').click(function(e)
                {
                    e.preventDefault();
                    var submenu = $(this).siblings('ul');
                    var li = $(this).parents('li');
                    var submenus = $('#sidebar li.submenu ul');
                    var submenus_parents = $('#sidebar li.submenu');
                    if(li.hasClass('open'))
                    {
                        if(($(window).width() > 768) || ($(window).width() < 479)) {
                            submenu.slideUp();
                        } else {
                            submenu.fadeOut(250);
                        }
                        li.removeClass('open');
                    } else 
                    {
                        if(($(window).width() > 768) || ($(window).width() < 479)) {
                            submenus.slideUp();         
                            submenu.slideDown();
                        } else {
                            submenus.fadeOut(250);          
                            submenu.fadeIn(250);
                        }
                        submenus_parents.removeClass('open');       
                        li.addClass('open');    
                    }
                });
                
                var ul = $('#sidebar > ul');
                
                $('#sidebar > a').click(function(e)
                {
                    e.preventDefault();
                    var sidebar = $('#sidebar');
                    if(sidebar.hasClass('open'))
                    {
                        sidebar.removeClass('open');
                        ul.slideUp(250);
                    } else 
                    {
                        sidebar.addClass('open');
                        ul.slideDown(250);
                    }
                });
        },
        computed:{
          showLeft:function(){
            return localStorage.user_type
          }
        },
        methods:{
           
        }
    }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/sidebar.vue
// module id = 51
// module chunks = 0